import { ShortcutData } from '../../../../../API/pcDashboard/CustomViewsApi';
import React, { useEffect } from 'react';
import { useCustomViewsContext } from './CustomViewsContext';
import { useFormikContext } from 'formik';
import { isNil } from 'lodash';

export type CustomViewsState = Closed | Open;
type Open = OpenRead | Edit;
type Edit = OpenEditList | OpenEditCreate | OpenEditUpdate;

type Closed = {
  isOpen: false;
  isCreate: false;
  isEdit: false;
  updatingView: null;
  formikData: null;
};

type OpenRead = {
  isOpen: true;
  isEdit: false;
  isCreate: false;
  updatingView: null;
  formikData: null;
};

type OpenEditList = {
  isOpen: true;
  isEdit: true;
  isCreate: false;
  updatingView: null;
  formikData: null;
};

type OpenEditCreate = {
  isOpen: true;
  isEdit: true;
  isCreate: true;
  updatingView: null;
  formikData: { dirty: boolean; isValid: boolean };
};

type OpenEditUpdate = {
  isOpen: true;
  isEdit: true;
  isCreate: false;
  updatingView: ShortcutData;
  formikData: { dirty: boolean; isValid: boolean };
};

const isFormState = (state: CustomViewsState): state is OpenEditCreate | OpenEditUpdate => {
  return !isNil(state.formikData);
};

/**
 * Updates the CustomViewsStateContext when it detects changes to the Formik form bag (specifically @dirty and @isValid).
 *
 * This component must be a child of the CustomViewsContextProvider and the Formik component.
 */
export const CustomViewsStateAndFormikContextConduit: React.FC = () => {
  const { setCustomViewsState } = useCustomViewsContext();
  const { dirty, isValid } = useFormikContext();
  useEffect(() => {
    setCustomViewsState((prev) => {
      if (!isFormState(prev)) {
        return prev;
      }
      return { ...prev, formikData: { dirty, isValid } };
    });
  }, [dirty, isValid, setCustomViewsState]);
  return <></>;
};
